import { englishType } from 'types'

export const lesson17: englishType[] = [
  {
    id: 1,
    word: "have in common",
    meaning: ["공통점이 있다"]
  }, {
    id: 2,
    word: "lift",
    meaning: ["양력"]
  }, {
    id: 3,
    word: "thrust",
    meaning: ["추력"]
  }, {
    id: 4,
    word: "drag",
    meaning: ["항력"]
  }, {
    id: 5,
    word: "oppose",
    meaning: ["반대하다"]
  }, {
    id: 6,
    word: "weight",
    meaning: ["무게", "중력"]
  }, {
    id: 7,
    word: "gravity",
    meaning: ["중력"]
  }, {
    id: 8,
    word: "constantly",
    meaning: ["지속적으로"]
  }, {
    id: 9,
    word: "propeller",
    meaning: ["프로펠러"]
  }, {
    id: 10,
    word: "interaction",
    meaning: ["상호작용"]
  }, {
    id: 11,
    word: "provide",
    meaning: ["제공하다"]
  }, {
    id: 12,
    word: "principle",
    meaning: ["원리", "원칙"]
  }, {
    id: 13,
    word: "still",
    meaning: ["정지된", "정지 상태의"]
  }, {
    id: 14,
    word: "result in",
    meaning: ["결과"]
  }, {
    id: 15,
    word: "upward",
    meaning: ["위쪽으로"]
  }, {
    id: 16,
    word: "strip",
    meaning: ["띠"]
  }, {
    id: 17,
    word: "evenly",
    meaning: ["균등하게"]
  }, {
    id: 18,
    word: "pressure",
    meaning: ["압력"]
  }, {
    id: 19,
    word: "experiment",
    meaning: ["실험"]
  }, {
    id: 20,
    word: "tension",
    meaning: ["장력"]
  }, {
    id: 21,
    word: "equivalent",
    meaning: ["동등한"]
  }, {
    id: 22,
    word: "uniqueness",
    meaning: ["독특함", "독특성"]
  }, {
    id: 23,
    word: "rectangular",
    meaning: ["직사각형"]
  }, {
    id: 24,
    word: "bamboo",
    meaning: ["대나무"]
  }, {
    id: 25,
    word: "width",
    meaning: ["가로", "폭", "너비"]
  }, {
    id: 26,
    word: "length",
    meaning: ["세로", "길이"]
  }, {
    id: 27,
    word: "proportion",
    meaning: ["비율"]
  }, {
    id: 28,
    word: "circular",
    meaning: ["원형의"]
  }, {
    id: 29,
    word: "diameter",
    meaning: ["지름"]
  }, {
    id: 30,
    word: "in accordance with",
    meaning: ["~에 따라서"]
  }, {
    id: 31,
    word: "at work",
    meaning: ["작용하여"]
  }, {
    id: 32,
    word: "stability",
    meaning: ["안정감"]
  }, {
    id: 33,
    word: "stably",
    meaning: ["안정적으로"]
  }, {
    id: 34,
    word: "spin",
    meaning: ["돌다", "회전하다"]
  }, {
    id: 35,
    word: "ancestor",
    meaning: ["조상", "선조"]
  },
]
